var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_615_5250",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_615_5250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.15298 22.8476L18.1957 18.2086L22.8347 9.16592L13.792 13.8049L9.15298 22.8476ZM16.0007 17.3333C15.6229 17.3333 15.3062 17.2055 15.0507 16.9499C14.7951 16.6944 14.6673 16.3777 14.6673 15.9999C14.6673 15.6221 14.7951 15.3055 15.0507 15.0499C15.3062 14.7944 15.6229 14.6666 16.0007 14.6666C16.3784 14.6666 16.6951 14.7944 16.9507 15.0499C17.2062 15.3055 17.334 15.6221 17.334 15.9999C17.334 16.3777 17.2062 16.6944 16.9507 16.9499C16.6951 17.2055 16.3784 17.3333 16.0007 17.3333ZM16.003 28.6666C14.2601 28.6666 12.6193 28.3341 11.0807 27.6693C9.54198 27.0044 8.19876 26.0984 7.05098 24.9513C5.90343 23.8039 4.99698 22.4613 4.33165 20.9233C3.66654 19.3853 3.33398 17.7449 3.33398 16.0023C3.33398 14.2503 3.66643 12.6035 4.33132 11.0619C4.99621 9.52036 5.90221 8.17947 7.04932 7.03925C8.19665 5.89903 9.53932 4.99625 11.0773 4.33092C12.6153 3.66581 14.2557 3.33325 15.9983 3.33325C17.7503 3.33325 19.3971 3.6657 20.9387 4.33058C22.4802 4.99547 23.8211 5.89781 24.9613 7.03759C26.1015 8.17736 27.0043 9.5177 27.6697 11.0586C28.3348 12.5995 28.6673 14.2458 28.6673 15.9976C28.6673 17.7405 28.3349 19.3813 27.67 20.9199C27.0051 22.4586 26.1028 23.8018 24.963 24.9496C23.8232 26.0971 22.4829 27.0036 20.942 27.6689C19.4011 28.334 17.7548 28.6666 16.003 28.6666ZM16.0007 26.9913C19.0627 26.9913 21.6601 25.9226 23.793 23.7853C25.9257 21.6479 26.992 19.0528 26.992 15.9999C26.992 12.9379 25.9257 10.3405 23.793 8.20758C21.6601 6.07492 19.0627 5.00859 16.0007 5.00859C12.9478 5.00859 10.3527 6.07492 8.21532 8.20758C6.07798 10.3405 5.00932 12.9379 5.00932 15.9999C5.00932 19.0528 6.07798 21.6479 8.21532 23.7853C10.3527 25.9226 12.9478 26.9913 16.0007 26.9913Z",
    fill: "#151515"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.d9743a3d4d6385fc1ec90af3d9eb1905.svg";
export { ForwardRef as ReactComponent };